"use client";
//#region packages/@mantine/core/src/core/MantineProvider/color-scheme-managers/is-mantine-color-scheme.ts
function isMantineColorScheme(value) {
	return value === "auto" || value === "dark" || value === "light";
}
//#endregion
export { isMantineColorScheme };

//# sourceMappingURL=is-mantine-color-scheme.mjs.map